module.exports = __webpack_public_path__ + "img/tth1.3e42d42a.jpg";